import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FuryCardModule } from '../../../@fury/shared/card/card.module';
import { ClickOutsideModule } from '../../../@fury/shared/click-outside/click-outside.module';
import { MaterialModule } from '../../../@fury/shared/material-components.module';
import { ScrollbarModule } from '../../../@fury/shared/scrollbar/scrollbar.module';
import { ToolbarFullscreenToggleComponent } from './toolbar-fullscreen-toggle/toolbar-fullscreen-toggle.component';
import { ToolbarSidenavMobileToggleComponent } from './toolbar-sidenav-mobile-toggle/toolbar-sidenav-mobile-toggle.component';
import { ToolbarComponent } from './toolbar.component';
import { ToolbarDarkmodeToggleComponent } from './toolbar-darkmode-toggle/toolbar-darkmode-toggle.component';
import { ToolbarWebformLinkComponent } from './toolbar-webform-link/toolbar-webform-link.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    ScrollbarModule,
    FormsModule,
    ClickOutsideModule,
    FuryCardModule
  ],
  declarations: [
    ToolbarComponent,
    ToolbarWebformLinkComponent,
    ToolbarFullscreenToggleComponent,
    ToolbarDarkmodeToggleComponent,
    ToolbarSidenavMobileToggleComponent,
  ],
  exports: [ToolbarComponent]
})
export class ToolbarModule {
}
